<app-modal title="Realtime VTEX">
  <div class="flex flex-col w-[90vw] max-w-[1200px] h-[80vh]">
    <div class="flex items-center justify-end gap-2 pb-2">
      <button
        type="button"
        (click)="copy()"
        class="inline-flex cursor-pointer items-center gap-1 rounded border border-neutral-700 bg-neutral-800 px-2.5 py-1 text-xs font-medium text-neutral-100 hover:bg-neutral-700"
      >
        @if (copied()) { Copiado! } @else { Copiar JSON }
      </button>
    </div>

    <pre class="postman-json flex-1 overflow-auto rounded border border-neutral-800 bg-[#1e1e1e] p-4 text-[12.5px] leading-[1.55]"
      [innerHTML]="html()"></pre>
  </div>
</app-modal>
